// Fail-open when the enabled-modules list is undefined (e.g. not yet loaded), matching
// the backend default of TrialModuleOrder.enabled=True for a module with no row.
export const isModuleEnabled = (enabledModules, moduleKey) =>
  !enabledModules || enabledModules.includes(moduleKey);
